import React from "react";
import { useNavigate } from "react-router";
import routes from "components/routes";
import { RadioWrapper, RadioListWrapper } from "./styles";
import UploadedSection from "./UploadedSection";

const UploadedInsuranceCard = ({ list }) => {
  const navigate = useNavigate()
  const addToSelected = (index, text) => {
    localStorage.setItem('mark_index', text[0])
    navigate(`/${routes.UPLOAD_DOCUMENT}/reupload`)
  };
  return (
    <RadioListWrapper>
      {list.map((text, index) => (
        <RadioWrapper key={index}>
          <UploadedSection
            text={text}
            onSelect={() => addToSelected(index, text)}
          />
        </RadioWrapper>
      ))}
    </RadioListWrapper>
  );
};

export default UploadedInsuranceCard;
